// extracted by mini-css-extract-plugin
module.exports = {"button":"create-role-modal_button_1kIZG","closableText":"create-role-modal_closableText_6LlFG"};